module.exports = __webpack_public_path__ + "media/images/stage-show-5438edb4e70a71c277656c186f3ee47e.jpg";